import { useEffect } from "react";

const HEADER_OFFSET = 96;

const scrollToQuote = () => {
  const el = document.getElementById("quote");
  if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET, behavior: "smooth" });
};

// Prefills the quote form from a Coach→B2B proposal handoff (sessionStorage, 30-min TTL). Returns true when applied.
export const useCoachHandoff = (setForm, setFromCoach) => {
  useEffect(() => {
    try {
      const raw = sessionStorage.getItem("tacc_coach_handoff");
      if (!raw) return;
      const handoff = JSON.parse(raw);
      if (!handoff || !handoff.summary) return;
      const ageMinutes = (Date.now() - (handoff.created_at || 0)) / 60000;
      if (ageMinutes > 30) { sessionStorage.removeItem("tacc_coach_handoff"); return; }
      setForm((f) => ({
        ...f,
        message: handoff.summary,
        tier: handoff.suggested_tier || f.tier,
        interested_in: Array.from(new Set([...(f.interested_in || []), "modules", "workshops"])),
      }));
      setFromCoach(true);
      sessionStorage.removeItem("tacc_coach_handoff");
      setTimeout(scrollToQuote, 350);
    } catch (e) {
      console.warn("Coach handoff skipped:", e);
    }
  }, [setForm, setFromCoach]);
};

export const useScrollToQuoteHash = () => {
  useEffect(() => {
    if (window.location.hash !== "#quote") return undefined;
    const t = setTimeout(scrollToQuote, 400);
    return () => clearTimeout(t);
  }, []);
};
